"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _ClickDropDown = require("./ClickDropDown.style");
var _l10n = require("../../../../../../../l10n");
var _mapIconKeyToUiKit = _interopRequireDefault(require("../../../../../../../utils/mapIconKeyToUiKit"));
var _withLocale = _interopRequireDefault(require("../../../../../../HOCs/withLocale"));
var _Wrapper = _interopRequireDefault(require("../../../../SubMenu/Wrapper"));
var _Functionality = require("../../Functionality.style");
var _Announcements = _interopRequireDefault(require("../Announcements"));
var _Search = _interopRequireDefault(require("../Search"));
const iconComponentMap = {
  search: _Search.default,
  announcements: _Announcements.default
};
/**
 * Renders the announcements functionality.
 *
 * @return {ReactElement} The markup to render
 */
// $FlowFixMe No definition exists for forwardRef (waiting on https://github.com/facebook/flow/pull/6510)
const ClickDropDown = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    locale,
    icon,
    children,
    navItemRef,
    setRef,
    selected,
    onFocus,
    onBlur,
    onClose,
    ...props
  } = _ref;
  const newIcon = (0, _mapIconKeyToUiKit.default)(icon);
  // @ts-ignore
  const Component = iconComponentMap[newIcon];
  /* istanbul ignore next */
  if (!Component) throw new Error('Unrecognised click drop down icon/component received');
  // @ts-ignore
  const itemText = (0, _l10n.getMessages)(locale)("NavIconAccessibilityText.".concat(newIcon));
  return /*#__PURE__*/React.createElement(_ClickDropDown.ClickDropDownWrapper, null, /*#__PURE__*/React.createElement(_ClickDropDown.TabableButton, {
    "aria-label": itemText,
    "aria-expanded": selected /* istanbul ignore next */ ? 'true' : 'false',
    "aria-controls": "navItem-".concat(itemText),
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(_Functionality.NavItemLinkWrapper, {
    selected: selected,
    isSelectable: true,
    ref: setRef(),
    "data-test-id": props.id,
    clickable: true
  }, children)), /*#__PURE__*/React.createElement(_Wrapper.default, {
    parentNavItem: navItemRef,
    showing: selected,
    positionToLeft: true,
    clickableDropDown: true,
    testId: "subMenu-".concat(props.id, "-wrapper")
  }, /*#__PURE__*/React.createElement(Component
  // @ts-ignore
  , Object.assign({
    id: "navItem-".concat(itemText),
    onClose: onClose,
    ref: ref,
    selected: selected
  }, props))));
});

// @ts-ignore
var _default = exports.default = (0, _withLocale.default)(ClickDropDown);